import { Styles } from '@t2c/shared-fe';

export const sideDrawerStyle: Styles = {
  container: {
    display: 'flex',
    flexDirection: { xs: 'row', sm: 'row' },
    minHeight: '93.5vh',
  },
  drawerBtnWrapper: {
    p: 1,
    // position: 'absolute',
    backgroundColor: (theme) => theme.palette.background.activeCard,
    border: (theme) => `1px solid ${theme.palette.background.border}`,
    borderRadius: '8px',
    padding: '4px',
    // right: '-18px',
    '&:hover': {
      backgroundColor: (theme) => theme.palette.background.secondary,
    },
  },
  drawerBtn: {
    fontSize: 20,
    color: (theme) => theme.palette.text.primary,
  },
  childrenWrapper: {
    flexGrow: 1,
    p: 0,
    pt: { xs: 0, md: 5 },
    position: 'relative',
    overflow: 'auto',
  },
};

export const menuListStyle: Styles = {
  listBtn: {
    minHeight: 48,
    px: 2.5,
  },
};
